export default [{
  name: 'repay/index',
  path: '/repay/index',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/repay/index.vue')
}, {
  name: 'repay/list',
  path: '/repay/list/:type',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/repay/list.vue')
}, {
  name: 'repay/await',
  path: '/repay/await',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/repay/await.vue')
}, {
  name: 'repay/prepayment',
  path: '/repay/prepayment',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/repay/prepayment.vue')
},
{
  name: 'repay/center',
  path: '/repay/center',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/repay/center.vue')
},
{
  name: 'repay/cards',
  path: '/repay/cards',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/repay/cards.vue')
},
]